import { render, staticRenderFns } from "./RegisteredMail.vue?vue&type=template&id=6693d2bc&"
import script from "./RegisteredMail.vue?vue&type=script&lang=js&"
export * from "./RegisteredMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports